// AOS Init

// window.addEventListener('DOMContentLoaded', function(e) {
//     if (document.referrer.includes(location.hostname)) {
//         let anim_container = document.querySelector('.loading-anim-wrapper');
//         if (anim_container) {
//             anim_container.setAttribute('style', 'display: none;');
//         }
//     }
// })

function setCookie(name) {
    document.cookie = name + "=true;";
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

window.addEventListener('DOMContentLoaded', function(e) {
    if (getCookie('loadAnimFlag')) {
        let anim_container = document.querySelector('.loading-anim-wrapper');
        if (anim_container) {
            anim_container.setAttribute('style', 'display: none;');
        }
    } else {
        setCookie('loadAnimFlag');
    }
})

window.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        duration: 1000,
        delay: 100,
        once: true
    });

    // Section Anchor Menu
    let body = document.querySelector("body").classList;
    let anchor_menu_toggle = document.querySelector(".anchor-menu-toggle");

    if (anchor_menu_toggle) {
        anchor_menu_toggle.onclick = function() {
            body.add("menu-open");
        };
    
        document.querySelector(".menu .close").onclick = function() {
            body.remove("menu-open");
        };

        window.addEventListener('click', function(e) {
            if (e.target.closest('.menu') == null && e.target.closest('.anchor-menu-toggle') == null) {
                body.remove("menu-open");
            }
        })
    }
})

import './navigation.js';
import './markets-slider.js';
import './timeline-slider.js';
import './parallax.js';
import './projects-filter';
import './slider-alt.js';
import './arrow-scroll.js';
import './team-grid.js';
import './menu-icon-color.js';
import './markets.js';
import './look-book.js';
import './news-load-more.js';
import './hero-slider';
import './grant-applications';
import './resume-capture';
import './form-thank-you';
import './extended-contact';